/**
 * User API
 */

import { defaults, patch, post, put, get, delete as _delete } from "axios";
import { Promise } from "es6-promise";
import Cookie from 'js-cookie'

defaults.baseURL = process.env.API_BASE_URL
defaults.headers.common['token'] = Cookie.get('CognitoIdentity.accessToken');
defaults.headers.common['provider'] = Cookie.get('CognitoIdentity.Provider');
defaults.headers.common['Accept'] = 'application/json';
defaults.headers.post['Content-Type'] = 'application/json';


export default {


  /**
   * Save New Password
   */
  saveNewPassword(params){
    return new Promise((resolve, reject) => {
      defaults.headers.common['token'] = process.env.UNIQUE_TOKEN
      let url = 'user/password'

      put(url, params)
      .then(function (res) {
        return resolve(res)
      })
      .catch(function (error) {
        return reject(error)
      })
    })
  },



  /**
   * Modify Email Attribute
   */
  modifyEmailAttributes(params){
    return new Promise((resolve, reject) => {
      let url = 'user/email'

      let body = {
        user_id: parseInt(params.userId),
        email: params.newEmail,
        accessToken: params.accessToken
      }

      post(url, body)
      .then(function (res) {
        return resolve(res)
      })
      .catch(function (error) {
        return reject(error)
      })
    })
  },


  /**
   * Send Password Reset Code
   */
  sendPasswordResetCode(params){
    return new Promise((resolve, reject) => {
      defaults.headers.common['token'] = process.env.UNIQUE_TOKEN
      let url = 'user/password'
      let body = {
        email: params.email
      }

      post(url, body)
      .then(function (res) {
        return resolve(res)
      })
      .catch(function (error) {
        return reject(error)
      })
    })
  },

  /**
   * User Sign Up
   */

  signup (user) {
    return new Promise((resolve, reject) => {
      defaults.headers.common['token'] = process.env.UNIQUE_TOKEN
      let url = 'user/register'
      post(url, user)
      .then(( response ) => {
        return resolve(response)
      })
      .catch(function (error) {
        return reject(error)
      })
    })
  },

  /**
   * Verify By Code
   */

  verifyByCode (params) {
    return new Promise((resolve, reject) => {
      defaults.headers.common['token'] = process.env.UNIQUE_TOKEN
      let url = 'user/register'
      patch(url, params)
      .then(( response ) => {
        return resolve(response)
      })
      .catch(function (error) {
        return reject(error)
      })
    })
  },


    /**
   * Verify Email Attribute
   */

  verifyModifiedEmail (params) {
    return new Promise((resolve, reject) => {
      // console.log(defaults.headers);
      defaults.headers.common['token'] = process.env.UNIQUE_TOKEN

      let url = 'user/verifyattribute'
      patch(url, params)
      .then(( response ) => {
        // console.log(response)
        return resolve(response)
      })
      .catch(function (error) {
        // console.log(error.response)
        return reject(error)
      })
    })
  },

 

  /**
   * Resend Confirmation code for change user attribute
   */
  resendConfirmation (params) {
    return new Promise((resolve, reject) => {
      defaults.headers.common['token'] = Cookie.get('CognitoIdentity.accessToken');
      defaults.headers.common['provider'] = Cookie.get('CognitoIdentity.Provider');   

      let url = 'user/email'
      let data = {
        accessToken: params.accessToken,
        type: params.type,
        email: params.email
      }

      put(url, data)
      .then(function (res) {
        if (res.status === 200) {
          return resolve(res)
        } else {
          return reject(res)
        }
      })
      .catch(function (error) {
        return reject(error)
      })
    })
  },

  

  /**
   * Delete User
   */
  deleteUser(params){
    return new Promise((resolve, reject) => {
      defaults.headers.common['token'] = Cookie.get('CognitoIdentity.accessToken');
      defaults.headers.common['provider'] = Cookie.get('CognitoIdentity.Provider');   

      let url = 'user'
      let bodyParams = {
        email: params.email,
        accessToken: params.accessToken
      }

      _delete(url, { data: bodyParams })
      .then(function (res) {
        if (res.status === 200) {
          return resolve(res.data)
        } else {
          return reject(res.data)
        }
      })
      .catch(function (error) {
        return reject(error)
      })
    })
  },
  

  
  /**
   * Update User Meta Attributes
   */
  updateUserMeta(params){
    return new Promise((resolve, reject) => {
      defaults.headers.common['token'] = Cookie.get('CognitoIdentity.accessToken');
      defaults.headers.common['provider'] = Cookie.get('CognitoIdentity.Provider');         
      let url = 'user/meta'

      put(url, params)
      .then(function (res) {
        return resolve(res)
      })
      .catch(function (error) {
        return reject(error)
      })
    })
  },


  /**
   * Update User Meta Attributes
   */
  getUserMeta(params){
    return new Promise((resolve, reject) => {
      let url = 'user/meta'
      get(url)
      .then(function (res) {
        return resolve(res)
      })
      .catch(function (error) {
        return reject(error)
      })
    })
  },

  /**
   * Check Uscer Existance
   * @param {*} cognitoId 
   */
  checkUserExistence(cognitoId){
    return new Promise((resolve, reject) => {
      defaults.headers.common['token'] = process.env.UNIQUE_TOKEN
      get('user/?cognitoIdentiyId='+cognitoId)
      .then((response) => {
        // console.log(response);
        if (response.status === 200) {
          return resolve(response.data.message);
        }else {
          return reject(response);
        }
      }).catch(function (error) { 
        return reject(error);
      });
    })
  },


  /**
   * get Nationality Master
   */
  getNationality() {
    return new Promise((resolve, reject) => {
      get('user/nationality')
        .then(response => resolve(response))
        .catch(error => reject(error))
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/user.js